export const getTrackingLogsType = (t: (key: string) => string): { [key: string]: string } => ({
  booking_payment_add: t('trackingLogs.bookingPaymentAdd'),
  booking_cash_payment_add: t('trackingLogs.bookingCashPaymentAdd'),
  booking_payment_removed: t('trackingLogs.bookingPaymentRemoved'),
  booking_payment_refunded: t('trackingLogs.bookingPaymentRefunded'),
  booking_checkin: t('trackingLogs.bookingCheckin'),
  booking_checkout: t('trackingLogs.bookingCheckout'),
  booking_undo_checkin: t('trackingLogs.bookingUndoCheckin'),
  booking_undo_checkout: t('trackingLogs.bookingUndoCheckout'),
  booking_booked: t('trackingLogs.bookingBooked'),
  booking_cancel: t('trackingLogs.bookingCancel'),
  booking_change_price: t('trackingLogs.bookingChangePrice'),
  booking_change_date: t('trackingLogs.bookingChangeDate'),
  booking_change_room: t('trackingLogs.bookingChangeRoom'),
  booking_assign_room: t('trackingLogs.bookingAssignRoom'),
  booking_change_room_type: t('trackingLogs.bookingChangeRoomType'),
  booking_change_note: t('trackingLogs.bookingChangeNote'),
  duplicated_booking_line: t('trackingLogs.duplicatedBookingLine'),
  undo_cancelled_booking: t('trackingLogs.undoCancelledBooking'),
  booking_change_medium: t('trackingLogs.bookingChangeMedium'),
  booking_change_source: t('trackingLogs.bookingChangeSource'),
  booking_change_campaign: t('trackingLogs.bookingChangeCampaign'),
  booking_change_travel_agency: t('trackingLogs.bookingChangeTravelAgency'),
  booking_change_guest: t('trackingLogs.bookingChangeGuest'),
  booking_remove_guest: t('trackingLogs.bookingRemoveGuest'),
  booking_change_guest_info: t('trackingLogs.bookingChangeGuestInfo'),
  booking_create_new_guest: t('trackingLogs.bookingCreateNewGuest'),
  booking_move_booking: t('trackingLogs.bookingMoveBooking'),
  booking_undo_moved_booking: t('trackingLogs.bookingUndoMovedBooking'),
  booking_set_master_room: t('trackingLogs.bookingSetMasterRoom'),
  booking_unset_master_room: t('trackingLogs.bookingUnsetMasterRoom')
});

export interface ParamsGetTrackingLogs {
  booking_line_id: number;
  start_date: string;
  end_date: string;
  type: string;
}
